import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as uma from './util-math.mjs'

function maybeCurrencyStruct(currency) {
  if (a.isStruct(currency)) return currency
  if (a.isStr(currency)) return c.CURRENCIES[currency.toLowerCase()]
  return undefined
}

export function currencyCode(currency) {
  if (a.isStr(currency)) return currency
  return a.laxStruct(maybeCurrencyStruct(currency)).code
}

export function currencySymbol(currency) {
  return a.laxStruct(maybeCurrencyStruct(currency)).symbol
}

export function formatCentsToUnitsUsd(cents) {
  return c.CURRENCY_USD.symbol + a.laxFin(uma.moneyCentsToUnits(cents))
}

// TODO dedup with `Amount..toString`.
export function formatAmount(currency, cents) {
  a.optValidStr(currency)
  a.optFin(cents)
  if (!currency && !cents) return ``

  a.reqFin(cents)
  a.reqValidStr(currency)

  const amount  = uma.moneyCentsToUnits(cents)
  const symbol  = a.laxStr(currencySymbol(currency))
  const code    = a.laxStr(currencyCode(currency))
  const codeStr = a.upper(code)

  return a.spaced(a.str(symbol, amount), codeStr)
}
